import React from 'react'
import { Box, Typography, useMediaQuery, Divider } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { useQuery } from 'react-query'

// Local imports
import CreditDocument from '../components/creditDocument'
import CreditExpiry from '../components/creditExpiry'
import CreditApproval from '../components/creditApproval'
import CloseRequestWarning from '../components/closeRequestWarning'

// API services
import { getLeavePolicies, usePutLeavePolicy } from 'services/api/modules/leave/leavePolicy'
import AdxButton from 'components/custom/AdxButton'

function EditLeaveCredit() {
  let navigate = useNavigate()
  let theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('sm'))

  const { data } = useQuery(['leave-policy', { type: 3 }], async () => {
    const { data: apiData } = await getLeavePolicies()
    return apiData.data.leave_credit[0]
  })
  const mutation = usePutLeavePolicy()

  const filler = () => {
    return {
      padding: 0,
      margin: 0,
      boxSizing: 'border-box',
      width: '15vw',
      minHeight: '100vh',
      backgroundColor: 'gray-background.main',
    }
  }

  const Header = () => {
    return (
      <Box
        p={3}
        display={'flex'}
        alignItems={'center'}
        position={'fixed'}
        top={0}
        width={1}
        left={0}
        sx={{ backgroundColor: 'background.main' }}
        minWidth={1}
        justifyContent={'space-between'}
        borderBottom={'1px solid'}
        borderColor={'grayscale.line-light'}
        zIndex={10}
      >
        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
          Leave Credit Request Policy
        </Typography>
        <CloseRequestWarning />
      </Box>
    )
  }

  const validationSchema = Yup.object().shape({
    attachment_required: Yup.boolean(),
    credit_expiry_period: Yup.string().required('Select one of the expiry period'),
    credit_expiry_amount: Yup.number()
      .nullable()
      .when(['credit_expiry_period'], {
        is: (period) => period !== 'cycle_period' && period !== 'no_expiry',
        then: (schema) =>
          schema.required('Required').moreThan(0, ({ more }) => `Must be more than ${more}`),
        otherwise: (schema) => schema.optional(),
      }),
    approval_route_id: Yup.number().required('Select one of the approval layer'),
  })

  return (
    <Box display={'flex'} sx={{ minHeight: '100vh', width: '100vw', alignItems: 'center' }}>
      {matches ? <Box sx={{ ...filler() }}></Box> : null}
      <Box
        display={'flex'}
        flexDirection={'column'}
        sx={{
          backgroundColor: 'white.main',
          width: '70%',
          paddingY: 10,
        }}
      >
        <Header />
        {/* Formik */}
        <Formik
          enableReinitialize
          initialValues={{
            attachment_required: data?.attachment_required,
            reason_required: data?.reason_required,
            credit_expiry_amount: data?.credit_expiry_amount,
            credit_expiry_period: data?.credit_expiry_period,
            approval_route_id: data?.approval_route_id || '',
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            const postData = {
              ...data,
              ...values,
              ...(data?.status === 3 && { status: 1 }),
              entitlement: [],
              credit_expiry_amount:
                values.credit_expiry_period === 'no_expiry' ||
                values.credit_expiry_period === 'cycle_period'
                  ? 0
                  : values.credit_expiry_amount,
            }
            mutation.mutate(
              { id: data.id, data: postData, type: data.type },
              {
                onSuccess: () => navigate(-1),
              }
            )
          }}
        >
          {(formikBag) => (
            <Form>
              <Box p={3} sx={{}}>
                <Box
                  height={1}
                  width={1}
                  display={'flex'}
                  flexDirection={'column'}
                  sx={{ rowGap: 1.5, backgroundColor: 'white.main' }}
                >
                  <CreditDocument formikBag={formikBag} />
                  <CreditExpiry formikBag={formikBag} />
                  <CreditApproval formikBag={formikBag} />
                </Box>
              </Box>
              <Box
                display={'flex'}
                justifyContent={'flex-end'}
                position={'fixed'}
                bottom={0}
                left={0}
                width={1}
                px={3}
                py={2}
                bgcolor={'primary.light'}
                border={'1px solid'}
                borderColor={'grayscale.line-light'}
                gap={1}
              >
                <CloseRequestWarning button />
                <AdxButton
                  variant={'contained'}
                  isLoading={mutation.isLoading}
                  disabled={mutation.isLoading}
                  onClick={() => formikBag.submitForm()}
                  sx={{ width: 200 }}
                >
                  Save
                </AdxButton>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
      {matches ? <Box sx={{ ...filler() }}></Box> : null}
    </Box>
  )
}

export default EditLeaveCredit
